module.exports = __webpack_public_path__ + "static/media/Meeting-1.41add7f7.gif";